var Numeric = function (props) {
    var number = props.number;
    number = number.replace(",", ".");
    var intPart = number.split(".")[0];
    var _a = number.split("."), floatingPart = _a[1];
    intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return intPart + (floatingPart ? ".".concat(floatingPart) : "");
};
export default Numeric;
